import { isDocSite } from '@/utils/url'
import { Message } from '@cx/ui'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

export type BasicResponse<T> = {
  code: number
  data: T
  message: string
}

export type ErrorResponse = {
  error: number
  data?: never
  code?: never
  message: string
}

export type Response<T> = BasicResponse<T> | ErrorResponse

//*牧云主机管理助手无登录路由
///cw-host-manage/share?token=cg00rnp7ch937ohotau0

const appUrlRedirect = (app_scope: string) => {
  const path = location.pathname
  if (app_scope) {
    return path.includes('app') && path.includes('share')
  }
}

const messagePath = /message\/\.*/
const landingPath = /landing\/\.*/
const toolsPath = /tools(?:\/\.*)?/
const vuldbPath = /vuldb(?:\/\.*)?/

const redirectToLogin = () => {
  if (
    location.pathname === '/' &&
    (location.search.indexOf('promotion') > -1 || location.search.indexOf('share') > -1) &&
    location.search.indexOf('redirect') === -1
  ) {
    const redirectAfterLogin = encodeURIComponent(`/console/workbench${location.search}`)
    const search = `redirect=${redirectAfterLogin}`
    const pathname = '/login'
    window.open([pathname, search]?.join('?'), '_self')
  } else if (
    location.pathname !== '/login' &&
    location.pathname !== '/register' &&
    location.pathname !== '/' &&
    !messagePath.test(location.pathname) &&
    !landingPath.test(location.pathname) &&
    !toolsPath.test(location.pathname) &&
    !vuldbPath.test(location.pathname) &&
    !appUrlRedirect('cw-host-manage')
  ) {
    const redirectAfterLogin = encodeURIComponent(location.href.replace(location.origin, ''))
    const search = `redirect=${redirectAfterLogin}`
    const pathname = '/login'
    window.open([pathname, search]?.join('?'), '_self')
  }
}

export const noneAuthClient = async <T>(option: AxiosRequestConfig) => {
  axios.defaults.withCredentials = true
  const client = axios.create({
    baseURL: '/api',
    timeout: 10000,
  })

  client.interceptors.response.use(undefined, (err) => {
    if (err?.response?.status === 401) {
      if (err?.request?.responseURL.indexOf('user/profile') === -1) {
        if (!isDocSite) {
          redirectToLogin()
        }
      }
      return Promise.reject(new Error('尚未登录'))
    }
    return Promise.reject(err)
  })

  return client(option).then((resp: AxiosResponse<Response<T>>) => {
    // if (resp.data.code === 4005) {
    //   return Promise.reject(resp.data.code)
    // } else
    if (resp.data.code !== 0) {
      return Promise.reject(resp.data.message)
    } else {
      return Promise.resolve(resp.data.data)
    }
  })
}

const client = async <T>(option: AxiosRequestConfig & { isAlert?: boolean }) => {
  const { isAlert = true, ...otherOption } = option
  axios.defaults.withCredentials = true
  const client = axios.create({
    baseURL: '/api/v1',
    timeout: 10000,
  })

  client.interceptors.response.use(undefined, (err) => {
    if (err?.response?.status === 401) {
      if (!isDocSite) {
        redirectToLogin()
      }
      return Promise.reject(new Error('尚未登录'))
    }
    if (err?.response?.status === 403) {
      location.href = '/'
    }

    if (err?.response?.status === 413) {
      Message.error('上传文件过大，请重新上传')
    }

    return Promise.reject(err)
  })

  return client(otherOption).then(
    (resp: AxiosResponse<Response<T>>) => {
      // if (resp.data.code === 4005) {
      //   return Promise.reject(resp.data.code)
      // // } else if (resp.data.code === 4123) {
      // //   return Promise.reject(resp.data.code)
      // // } else if (resp.data.code === 4127) {
      // //   return Promise.reject(resp.data.code)
      // } else
      if (resp.data.code !== 0) {
        if (isAlert) {
          Message.error(resp.data.message)
        }
        return Promise.reject(resp.data.message)
      } else {
        return Promise.resolve(resp.data.data)
      }
    },
    // , (err) => {
    //   const message = err?.response?.data?.message || err?.message
    //   Message.error(message)
    //   return Promise.reject(message)
    // }
  )
}

export default client
